<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />

    <v-form ref="form">
      <div class="text-h4 mb-7">Cadastro de Áudio</div>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :counter="30"
            label="Descrição do Áudio"
            outlined
            :error-messages="descriptionErrors"
            @input="
              $v.form.description.$touch();
              form.description = $event.toUpperCase().trim();
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-file-input
            outlined
            dense
            show-size
            counter
            accept="audio/wav"
            label="Escolha seu áudio"
            v-model="form.files"
            prepend-icon=""
            append-icon="mdi-file-music"
          />
        </v-col>
      </v-row>
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'

import FixedButtons from '@/componentes/FixedButtons'
import Snackbar from '@/componentes/Snackbar'

import { validateData, validateComputed } from '../_validates'
import AudiosHttpService from '../_services/AudiosHttpService'

export default {
  name: 'CadastroAudio',
  components: { Snackbar, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      files: [],
    },
    text: '',
    snackbar: false,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
  },

  methods: {
    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }

      try {
        await AudiosHttpService.postAudio(this.form)
        this.$router.push({ name: 'Audios' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Audios' })
    },
  },
}
</script>
